// Format.Id — branded format identifier.
//
// The floor predicate differs slightly from other id brands (it only
// trims/rejects empty), so `Format.Id.to` is written inline rather
// than reused from `_ids/parse`. This keeps the option open for
// Format-specific naming rules (e.g. `F_xxx` prefixes) later.
export { from, mk, to };
import { Result } from "@bilda/utils";
import * as IdError from "../idError.js";
const mk = (s) => s;
const to = (s) => {
    if (s.length === 0 || s !== s.trim()) {
        return Result.err(IdError.mkMalformed("FormatId", s));
    }
    return Result.ok(mk(s));
};
const from = (id) => id;
//# sourceMappingURL=id.js.map